export default __webpack_public_path__ + "static/media/p4.a7cc53a9.svg";